import * as React from 'react';

import { Pager, TableActions } from '@lightspeed/cirrus-table';
import { Bone } from '@lightspeed/flame/Bone';
import { Flex } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';

interface Pagination {
  next?: string;
  previous?: string;
  count?: number;
  perPage: number;
  currentPage: number;
  handlePrevious?: () => void;
  handleNext?: () => void;
  direction?: 'previous' | 'next' | null;
}

interface Props {
  isLoading: boolean;
  isInitialLoading: boolean;
  pagination: Pagination;
}

const Pagination: React.FC<Props> = ({ isLoading, isInitialLoading, pagination }) => {
  const {
    next,
    previous,
    count = 0,
    perPage,
    currentPage,
    handlePrevious,
    handleNext,
    direction,
  } = pagination;

  const isFirst = !previous;
  const isLast = !next;

  let calculatedCurrentPage = currentPage;
  if (isLoading && direction) {
    if (direction === 'next') {
      calculatedCurrentPage += 1;
    } else if (direction === 'previous') {
      calculatedCurrentPage -= 1;
    }
  }

  const pageStart = calculatedCurrentPage * perPage - (perPage - 1);
  const maxPageIndex =
    calculatedCurrentPage * perPage > count ? count : calculatedCurrentPage * perPage;

  return (
    <TableActions.ActionsBar
      rightHandActions={
        <Pager
          isFirst={isFirst}
          isLast={isLast}
          handlePrevious={isLoading ? undefined : handlePrevious}
          handleNext={isLoading ? undefined : handleNext}
        >
          <Flex>
            {isInitialLoading ? (
              <Bone height={3} width="40px" />
            ) : (
              <Text>
                <var style={{ fontWeight: 'bold' }}>
                  {count ? `${pageStart}-${maxPageIndex}` : '0'}
                </var>{' '}
                of <var>{count}</var>
              </Text>
            )}
          </Flex>
        </Pager>
      }
    />
  );
};

export default Pagination;
